import extend from './extend';
import { surveyActionTypeMap, surveyConditionTypeMap, surveyLogicRuleMap, surveyTaggingResultTypeMap, } from './survey.logic';
export * from './survey.logic';
export * from './survey.project';
export var SurveyQuestionType;
(function (SurveyQuestionType) {
    SurveyQuestionType[SurveyQuestionType["ShortTextResponse"] = 1] = "ShortTextResponse";
    SurveyQuestionType[SurveyQuestionType["MultipleChoice"] = 2] = "MultipleChoice";
    SurveyQuestionType[SurveyQuestionType["LongTextResponse"] = 3] = "LongTextResponse";
    SurveyQuestionType[SurveyQuestionType["Multiselect"] = 4] = "Multiselect";
    SurveyQuestionType[SurveyQuestionType["Ranking"] = 5] = "Ranking";
    SurveyQuestionType[SurveyQuestionType["MatrixGrid"] = 6] = "MatrixGrid";
    SurveyQuestionType[SurveyQuestionType["MaxDifference"] = 7] = "MaxDifference";
    SurveyQuestionType[SurveyQuestionType["ConjointAnalysis"] = 8] = "ConjointAnalysis";
    SurveyQuestionType[SurveyQuestionType["Sliders"] = 9] = "Sliders";
    SurveyQuestionType[SurveyQuestionType["MatrixMultiselect"] = 10] = "MatrixMultiselect";
    SurveyQuestionType[SurveyQuestionType["NumberInputTable"] = 11] = "NumberInputTable";
    SurveyQuestionType[SurveyQuestionType["MultiTextbox"] = 12] = "MultiTextbox";
    SurveyQuestionType[SurveyQuestionType["ExclusiveOptions"] = 13] = "ExclusiveOptions";
    SurveyQuestionType[SurveyQuestionType["Dropdown"] = 14] = "Dropdown";
    SurveyQuestionType[SurveyQuestionType["MatrixRange"] = 15] = "MatrixRange";
    SurveyQuestionType[SurveyQuestionType["ImageMarkup"] = 16] = "ImageMarkup";
})(SurveyQuestionType || (SurveyQuestionType = {}));
const surveyQuestionTypeMap = new Map([
    [SurveyQuestionType.ShortTextResponse, { name: 'Short Text Response' }],
    [SurveyQuestionType.MultipleChoice, { name: 'Multiple Choice' }],
    [SurveyQuestionType.LongTextResponse, { name: 'Long Text Response' }],
    [SurveyQuestionType.Multiselect, { name: 'Multiselect' }],
    [SurveyQuestionType.Ranking, { name: 'Ranking' }],
    [SurveyQuestionType.MatrixGrid, { name: 'Matrix Grid' }],
    [SurveyQuestionType.MaxDifference, { name: 'MaxDiff' }],
    [SurveyQuestionType.ConjointAnalysis, { name: 'Conjoint Analysis' }],
    [SurveyQuestionType.Sliders, { name: 'Sliders' }],
    [SurveyQuestionType.MatrixMultiselect, { name: 'Matrix Multiselect' }],
    [SurveyQuestionType.NumberInputTable, { name: 'Number Input Table' }],
    [SurveyQuestionType.MultiTextbox, { name: 'Multiple Textboxes' }],
    [SurveyQuestionType.ExclusiveOptions, { name: 'Exclusive Options' }],
    [SurveyQuestionType.Dropdown, { name: 'Dropdown' }],
    [SurveyQuestionType.MatrixRange, { name: 'Matrix Range' }],
    [SurveyQuestionType.ImageMarkup, { name: 'Image Markup' }],
]);
export var SurveyTypeOld;
(function (SurveyTypeOld) {
    SurveyTypeOld["Compliance"] = "compliance";
    SurveyTypeOld["Project"] = "project";
})(SurveyTypeOld || (SurveyTypeOld = {}));
export var SurveyType;
(function (SurveyType) {
    SurveyType[SurveyType["GroupCompliance"] = 1] = "GroupCompliance";
    SurveyType[SurveyType["Project"] = 2] = "Project";
    SurveyType[SurveyType["ProjectScreening"] = 3] = "ProjectScreening";
    SurveyType[SurveyType["AnalystPostCall"] = 4] = "AnalystPostCall";
    SurveyType[SurveyType["Module"] = 5] = "Module";
    SurveyType[SurveyType["ConferenceQuant"] = 6] = "ConferenceQuant";
})(SurveyType || (SurveyType = {}));
const surveyTypeMap = new Map([
    [SurveyType.GroupCompliance, { name: 'Group Compliance' }],
    [SurveyType.Project, { name: 'Survey/Screener' }],
    [SurveyType.ProjectScreening, { name: 'Project Screener' }],
    [SurveyType.AnalystPostCall, { name: 'Analyst Post Call' }],
    [SurveyType.Module, { name: 'Module' }],
    [SurveyType.ConferenceQuant, { name: 'Capture Sheet' }],
]);
export var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus[SurveyStatus["NotRequired"] = 1] = "NotRequired";
    SurveyStatus[SurveyStatus["Incomplete"] = 2] = "Incomplete";
    SurveyStatus[SurveyStatus["Completed"] = 3] = "Completed";
})(SurveyStatus || (SurveyStatus = {}));
export var SurveyQuestionTaggingActionType;
(function (SurveyQuestionTaggingActionType) {
    SurveyQuestionTaggingActionType[SurveyQuestionTaggingActionType["ProductPositiveAffinity"] = 1] = "ProductPositiveAffinity";
    SurveyQuestionTaggingActionType[SurveyQuestionTaggingActionType["ProductNegativeAffinity"] = 2] = "ProductNegativeAffinity";
})(SurveyQuestionTaggingActionType || (SurveyQuestionTaggingActionType = {}));
export var SurveyQuotaType;
(function (SurveyQuotaType) {
    SurveyQuotaType[SurveyQuotaType["Basic"] = 1] = "Basic";
    SurveyQuotaType[SurveyQuotaType["Advanced"] = 2] = "Advanced";
})(SurveyQuotaType || (SurveyQuotaType = {}));
export var SurveyOptionType;
(function (SurveyOptionType) {
    SurveyOptionType[SurveyOptionType["Default"] = 1] = "Default";
    SurveyOptionType[SurveyOptionType["NotApplicable"] = 2] = "NotApplicable";
    // Other = 3,
    SurveyOptionType[SurveyOptionType["NoneOfTheAbove"] = 4] = "NoneOfTheAbove";
})(SurveyOptionType || (SurveyOptionType = {}));
export var SurveyItemType;
(function (SurveyItemType) {
    SurveyItemType[SurveyItemType["Question"] = 1] = "Question";
    SurveyItemType[SurveyItemType["Message"] = 2] = "Message";
    SurveyItemType[SurveyItemType["AlternateImageExercise"] = 3] = "AlternateImageExercise";
})(SurveyItemType || (SurveyItemType = {}));
const surveyItemTypeMap = new Map([
    [SurveyItemType.Question, { name: 'Question' }],
    [SurveyItemType.Message, { name: 'Message' }],
    [SurveyItemType.AlternateImageExercise, { name: 'Stimuli Sequence' }],
]);
export var DerivedResponseStatus;
(function (DerivedResponseStatus) {
    DerivedResponseStatus["active"] = "active";
    DerivedResponseStatus["compliance"] = "compliance";
    DerivedResponseStatus["disqualified"] = "disqualified";
    DerivedResponseStatus["ready"] = "ready";
    DerivedResponseStatus["rejected"] = "rejected";
    DerivedResponseStatus["removed"] = "removed";
    DerivedResponseStatus["review"] = "review";
    DerivedResponseStatus["quotaoverlimit"] = "quotaoverlimit";
    DerivedResponseStatus["incomplete"] = "incomplete";
})(DerivedResponseStatus || (DerivedResponseStatus = {}));
export default {
    SurveyActionType: extend(surveyActionTypeMap),
    SurveyItemtype: extend(surveyItemTypeMap),
    SurveyLogicRule: extend(surveyLogicRuleMap),
    SurveyQuestionConditionType: extend(surveyConditionTypeMap),
    SurveyQuestionType: extend(surveyQuestionTypeMap),
    SurveyTaggingResultType: extend(surveyTaggingResultTypeMap),
    SurveyType: extend(surveyTypeMap),
};
